import { environment } from 'src/environments/environment';

export const ApiEndpoints = {
  Identity: {
    Authenticate: environment.mainapiUrl + '/identity/authenticate',
    DispatcherLogin: environment.mainapiUrl + '/identity/dispatcher-login',
    CustomerLogin: environment.mainapiUrl + '/identity/customer-login',
    CustomersLoginUsingSSo:
      environment.mainapiUrl + '/identity/customers-login-using-sso',
    DriverLogin: environment.mainapiUrl + '/identity/driver-login',
    CheckIfEmailExist:
      environment.mainapiUrl + '/identity/check-existing-email/',
    Logout: environment.mainapiUrl + '/identity/logout',
    SendVerificationCodeForResetPassword:
      environment.mainapiUrl + '/identity/reset-password-verification',
    ValidateVerificationCodeForResetPassword:
      environment.mainapiUrl + '/identity/reset-password-validation',
    ResetPassword: environment.mainapiUrl + '/identity/reset-password',
  },
  CommonApis: {
    GetVehiclesForDropDownLists:
      environment.mainapiUrl + '/common/vehicles-lists',
    GoogleCustomToken: environment.messagingUrl + '/conversations/custom-token',
    regionsLocations:
      environment.mainapiUrl + '/regions-locations/get-location-name-by-ids',
  },
  ConfigurationsApi: {
    GetAllConfigurations: `${environment.mainapiUrl}/configuration/configurations`,
    GetGoogleAPIConfigurations: `${environment.mainapiUrl}/configuration/configuration/`,
  },
  Route: {
    getAllVehiclesList: `${environment.mainapiUrl}/route/get-all-vehicles-list`,
    routesByMultiLocations: `${environment.dispatchUrl}/route/routes-by-multi-locations`,
    Allroutesfordropdownlist: `${environment.dispatchUrl}/route/get-all-routes-for-drop-down-list`,
  },

  Tools: {
    GetAllTools: `${environment.mainapiUrl}/tools/get-all`,
    GetAllToolsForDraw: `${environment.mainapiUrl}/tools/gdraw`,
    GetToolsById: `${environment.mainapiUrl}/tools/get/`,
    PostTools: `${environment.mainapiUrl}/tools/add`,
    PutTools: `${environment.mainapiUrl}/tools/edit`,
    UpdateToolsStatus: `${environment.mainapiUrl}/tools/update-status/`,
    CheckToolExists: `${environment.mainapiUrl}/tools/check-exists/`,
  },

  TasksAssignments: {
    GetAllTasksAssignments: `${environment.dispatchUrl}/task-assignment/get-all`,
    CreateTaskAssignment: `${environment.dispatchUrl}/task-assignment`,
    GetTaskAssignmentById: `${environment.dispatchUrl}/task-assignment/get-by-id`,
    EditTaskAssignment: `${environment.dispatchUrl}/task-assignment`,
    DeleteTaskAssignment: `${environment.dispatchUrl}/task-assignment`,
    UpdateTaskAssignmentStatus: `${environment.dispatchUrl}/task-assignment/update-status`,
  },

  BI: {
    get_guest_token: `${environment.BIUrl}/guest-token`,
  },

  BIAction: {
    GetAllUsers: `${environment.BIUrl}/action/get-all-users`,
    ShareDashboard: `${environment.BIUrl}/action/share-dashboard`,
    SubmitInquiry: `${environment.BIUrl}/action/submit-inquiry`,
    get_dashboards: `${environment.BIUrl}/action/get-dashboards`,
    get_earning_code: `${environment.BIUrl}/action/get-earning-code`,
    get_pay_component_group: `${environment.BIUrl}/action/get-pay-component-group`,
    get_periods: `${environment.BIUrl}/action/get-periods`,
    get_all_lookup_by_id: `${environment.BIUrl}/action/get-all-lookup-by-id`,
    get_locations_without_vehicles: `${environment.BIUrl}/action/get_locations_without_vehicles`,
  },

  BICard: {
    get_overtime_header: `${environment.BIUrl}/card/get-overtime-header`,
    get_deadhead_header: `${environment.BIUrl}/card/get-deadhead-header`,
    get_paid_routed_time_header: `${environment.BIUrl}/card/get-paid-routed-time-header`,
    get_paid_routed_time_drilldown_header: `${environment.BIUrl}/card/get-paid-routed-time-drilldown-header`,
    get_time_monitoring_drill_down_workday_grp: `${environment.BIUrl}/card/get-time-monitoring-drill-down-workday-grp`,
    get_time_monitoring_drill_down_by_tecurve_grp: `${environment.BIUrl}/card/get-time-monitoring-drill-down-workday-by-teCurve-grp`,
    get_route_schedule_actual_paid_drill_down: `${environment.BIUrl}/card/get-route-schedule-actual-paid-drill-down`,
    export_chart: `${environment.BIUrl}/card/export-chart`,
    share_chart: `${environment.BIUrl}/card/share-chart`,
    copy_chart: `${environment.BIUrl}/card/copy-chart`,
    get_deadhead_header_share: `${environment.BIUrl}/card/get-deadhead-header-share`,
    get_overtime_header_share: `${environment.BIUrl}/card/get-overtime-header-share`,
    get_paid_routed_time_header_share: `${environment.BIUrl}/card/get-paid-routed-time-header-share`,
    get_paid_routed_time_header_export: `${environment.BIUrl}/card/get-paid-routed-time-header-export`,
    get_paid_routed_time_header_copy: `${environment.BIUrl}/card/get-paid-routed-time-header-copy`,
    ge_overtime_header_export: `${environment.BIUrl}/card/get-overtime-header-export`,
    ge_overtime_header_copy: `${environment.BIUrl}/card/get-overtime-header-copy`,
    get_deadhead_header_export: `${environment.BIUrl}/card/get-deadhead-header-export`,
    get_deadhead_header_copy: `${environment.BIUrl}/card/get-deadhead-header-copy`,
    get_time_monitoring: `${environment.BIUrl}/card/get-time-monitoring`,
    get_time_monitoring_share: `${environment.BIUrl}/card/get-time-monitoring-share`,
    get_time_monitoring_export: `${environment.BIUrl}/card/get-time-monitoring-export`,
    get_time_monitoring_copy: `${environment.BIUrl}/card/get-time-monitoring-copy`,
    get_time_trending: `${environment.BIUrl}/card/get-time-trending`,
    get_time_trending_share: `${environment.BIUrl}/card/get-time-trending-share`,
    get_time_trending_export: `${environment.BIUrl}/card/get-time-trending-export`,
    get_time_trending_copy: `${environment.BIUrl}/card/get-time-trending-copy`,
    get_rout_schdule_actul_paid: `${environment.BIUrl}/card/get-rout-schdule-actul-paid`,
    get_rout_schdule_actul_paid_share: `${environment.BIUrl}/card/get-rout-schdule-actul-paid-share`,
    get_rout_schdule_actul_paid_export: `${environment.BIUrl}/card/get-rout-schdule-actul-paid-export`,
    get_rout_schdule_actul_paid_copy: `${environment.BIUrl}/card/get-rout-schdule-actul-paid-copy`,
    get_overtime_drilldown_grp: `${environment.BIUrl}/card/get-overtime-drilldown-grp`,
    get_overtime_drilldown_Monitor_grp: `${environment.BIUrl}/card/get-overtime-drilldown-monitor-grp`,
    get_routed_time_drilldown_grp: `${environment.BIUrl}/card/get-routed-time-drilldown-grp`,
    get_paid_routed_time_drilldown_grp: `${environment.BIUrl}/card/get-paid-routed-time-drilldown-grp`,
    get_paid_routed_time_drillMonitordown_grp: `${environment.BIUrl}/card/get-overtime-drilldown-monitor-grp`,
    export_overtime_drilldown: `${environment.BIUrl}/card/export-overtime-drilldown`,
    export_overtime_drilldown_monitors: `${environment.BIUrl}/card/export-overtime-drilldown-monitors`,
    export_paid_routed_time_drilldown: `${environment.BIUrl}/card/export-paid-routed-time-drilldown`,
    export_routed_time_drilldown: `${environment.BIUrl}/card/export-routed-time-drilldown`,
    export_time_monitoring_drill_down_workday: `${environment.BIUrl}/card/export-time-monitoring-drill-down-workday`,
    export_time_monitoring_drill_down_workday_by_tecurve: `${environment.BIUrl}/card/export-time-monitoring-drill-down-workday-by-teCurve`,
    export_route_schedule_actual_paid_drill_down: `${environment.BIUrl}/card/export-route-schedule-actual-paid-drill-down`,
    copy_overtime_drilldown: `${environment.BIUrl}/card/copy-overtime-drilldown`,
    copy_overtime_drilldown_monitors: `${environment.BIUrl}/card/copy-overtime-drilldown-monitors`,
    copy_paid_routed_time_drilldown: `${environment.BIUrl}/card/copy-paid-routed-time-drilldown`,
    copy_routed_time_drilldown: `${environment.BIUrl}/card/copy-routed-time-drilldown`,
    copy_time_monitoring_drill_down_workday: `${environment.BIUrl}/card/copy-time-monitoring-drill-down-workday`,
    copy_time_monitoring_drill_down_workday_by_tecurve: `${environment.BIUrl}/card/copy-time-monitoring-drill-down-workday-by-teCurve`,
    copy_route_schedule_actual_paid_drill_down: `${environment.BIUrl}/card/copy-route-schedule-actual-paid-drill-down`,
    share_overtime_drilldown: `${environment.BIUrl}/card/share-overtime-drilldown`,
    share_overtime_drilldown_monitors: `${environment.BIUrl}/card/share-overtime-drilldown-Monitors`,
    share_paid_routed_time_drilldown: `${environment.BIUrl}/card/share-paid-routed-time-drilldown`,
    share_routed_time_drilldown: `${environment.BIUrl}/card/share-routed-time-drilldown`,
    share_time_monitoring_drill_down_workday: `${environment.BIUrl}/card/share-time-monitoring-drill-down-workday`,
    share_time_monitoring_drill_down_workday_by_tecurve: `${environment.BIUrl}/card/share-time-monitoring-drill-down-workday-by-teCurve`,
    share_route_schedule_actual_paid_drill_down: `${environment.BIUrl}/card/share-route-schedule-actual-paid-drill-down`,
    get_schedule_vs_actual_heatmap: `${environment.BIUrl}/card/get-schedule-vs-actual-time-heatmap`,
    get_labor_schedule_vs_actual_bar_chart: `${environment.BIUrl}/card/get-labor-schedule-vs-actual-bar-chart`,
    get_schedule_vs_actual_export: `${environment.BIUrl}/card/get-schedule-vs-actual-export`,
    get_schedule_vs_actual_copy: `${environment.BIUrl}/card/get-schedule-vs-actual-copy`,
    get_schedule_vs_actual_share: `${environment.BIUrl}/card/get-schedule-vs-actual-share`,
    get_schedule_vs_actual_drilldown: `${environment.BIUrl}/card/get-schedule-vs-actual-drilldown`,
    byte_curve_metric_status: `${environment.BIUrl}/card/byte-curve-metric-status`,
    buffer_times: `${environment.BIUrl}/card/buffer-times`,
    employee_attendance_analysis: `${environment.BIUrl}/card/employee-attendance-analysis`,
    byte_curve_statistics_drilldown: `${environment.BIUrl}/card/byte-curve-statistics-drilldown`,
    byte_curve_statistics_share: `${environment.BIUrl}/card/byte-curve-statistics-share`,
    byte_curve_statistics_export: `${environment.BIUrl}/card/byte-curve-statistics-export`,
    byte_curve_statistics_copy: `${environment.BIUrl}/card/byte-curve-statistics-copy`,
  },

  BIDashboards: {
    add_dashboard: `${environment.BIUrl}/dashboard/add-dashboard`,
    edit_dashboard: `${environment.BIUrl}/dashboard/edit-dashboard`,
    delete_dashboard: `${environment.BIUrl}/dashboard/delete-dashboard`,
    update_dashboard_status: `${environment.BIUrl}/dashboard/update-status`,
    get_all_dashboards: `${environment.BIUrl}/dashboard/get-all-dashboards`,
  },

  SafetyDashboard: {
    get_risk_per_mile: `${environment.BIUrl}/dashboard/get-risk-per-mile`,
    get_collision_per_mile: `${environment.BIUrl}/dashboard/get-collision-per-mile`,
    get_injury_data: `${environment.BIUrl}/dashboard/get-injury-per-hours`,
    get_risk_per_mile_line_chart: `${environment.BIUrl}/dashboard/get-risk-per-mile-line-chart`,
    get_collision_per_mile_line_chart: `${environment.BIUrl}/dashboard/get-collision-per-mile-line-chart`,
    get_injury_per_hours_line_chart: `${environment.BIUrl}/dashboard/get-injury-per-hours-line-chart`,
    get_risk_distribution: `${environment.BIUrl}/dashboard/safety-risk-distribution`,
    get_risk_top_behavior_incidents: `${environment.BIUrl}/dashboard/safety-risk-top-behavior-incidents`,
    get_risk_top_drivers: `${environment.BIUrl}/dashboard/safety-risk-top-drivers`,
    get_risk_drivers_coachablescores: `${environment.BIUrl}/dashboard/safety-risk-drivers-coachablescores`,
    get_risk_recurring_drivers: `${environment.BIUrl}/dashboard/safety-risk-recurring-drivers`,
    get_risk_top_coachable_scores: `${environment.BIUrl}/dashboard/safety-top-drivers-by-coachable-score`,
    get_risk_drivers_month_over_month: `${environment.BIUrl}/dashboard/safety-risk-drivers-month-variance`,
    get_safety_collision_count: `${environment.BIUrl}/dashboard/safety-collision-count`,
    get_safety_locations_by_collisions: `${environment.BIUrl}/dashboard/safety-collision-by-location`,
    get_collision_by_drivers: `${environment.BIUrl}/dashboard/safety-collision-by-driver`,
    get_top_locations_by_injuries: `${environment.BIUrl}/dashboard/safety-injury-by-location`,
    get_safety_injuries_by_employees: `${environment.BIUrl}/dashboard/safety-injury-by-employee`,
    get_safety_injuries_lost_time: `${environment.BIUrl}/dashboard/safety-injury-lost-time`,
    get_safety_injuries_count: `${environment.BIUrl}/dashboard/safety-injury-count`,
    get_collision_top_relevant_factors: `${environment.BIUrl}/dashboard/safety-collision-top-relevant-factor`,
    get_collision_top_counts: `${environment.BIUrl}/dashboard/safety-collision-top-collision`,
    get_injury_top_relevant_conditions: `${environment.BIUrl}/dashboard/safety-injury-top-relevant-factor`,

    // Widget Actions - Key Performance Indicators
    copy_key_performance_indicators_card: `${environment.BIUrl}/dashboard/copy-key-performance-indicators-card`,
    export_key_performance_indicators_card: `${environment.BIUrl}/dashboard/export-key-performance-indicators-card`,
    share_key_performance_indicators_card: `${environment.BIUrl}/dashboard/share-key-performance-indicators-card`,

    // Widget Actions - Risk Per Mile Chart
    copy_risk_per_mile_line_chart: `${environment.BIUrl}/dashboard/copy-risk-per-mile-line-chart`,
    export_risk_per_mile_line_chart: `${environment.BIUrl}/dashboard/export-risk-per-mile-line-chart`,
    share_risk_per_mile_line_chart: `${environment.BIUrl}/dashboard/share-risk-per-mile-line-chart`,

    // Widget Actions - Collision Per Mile Chart
    copy_collision_per_mile_line_chart: `${environment.BIUrl}/dashboard/copy-collision-per-mile-line-chart`,
    export_collision_per_mile_line_chart: `${environment.BIUrl}/dashboard/export-collision-per-mile-line-chart`,
    share_collision_per_mile_line_chart: `${environment.BIUrl}/dashboard/share-collision-per-mile-line-chart`,

    // Widget Actions - Injury Per Hour Chart
    copy_injury_per_hours_line_chart: `${environment.BIUrl}/dashboard/copy-injury-per-hours-line-chart`,
    export_injury_per_hours_line_chart: `${environment.BIUrl}/dashboard/export-injury-per-hours-line-chart`,
    share_injury_per_hours_line_chart: `${environment.BIUrl}/dashboard/share-injury-per-hours-line-chart`,

    // Widget Actions - Risk Distribution
    copy_risk_distribution: `${environment.BIUrl}/dashboard/copy-safety-risk-distribution`,
    export_risk_distribution: `${environment.BIUrl}/dashboard/export-safety-risk-distribution`,
    share_risk_distribution: `${environment.BIUrl}/dashboard/share-safety-risk-distribution`,

    // Widget Actions - Top Behavior Incidents
    copy_top_behavior_incidents: `${environment.BIUrl}/dashboard/copy-safety-risk-top-behavior-incidents`,
    export_top_behavior_incidents: `${environment.BIUrl}/dashboard/export-safety-risk-top-behavior-incidents`,
    share_top_behavior_incidents: `${environment.BIUrl}/dashboard/share-safety-risk-top-behavior-incidents`,

    // Widget Actions - Top Drivers by Incidents
    copy_top_drivers_by_incidents: `${environment.BIUrl}/dashboard/copy-safety-risk-top-drivers`,
    export_top_drivers_by_incidents: `${environment.BIUrl}/dashboard/export-safety-risk-top-drivers`,
    share_top_drivers_by_incidents: `${environment.BIUrl}/dashboard/share-safety-risk-top-drivers`,

    // Widget Actions - Drivers Coachable Scores
    copy_risk_drivers_coachablescores: `${environment.BIUrl}/dashboard/copy-safety-risk-drivers-coachablescores`,
    export_risk_drivers_coachablescores: `${environment.BIUrl}/dashboard/export-safety-risk-drivers-coachablescores`,
    share_risk_drivers_coachablescores: `${environment.BIUrl}/dashboard/share-safety-risk-drivers-coachablescores`,

    // Widget Actions - Top Coachable Scores
    copy_risk_top_coachable_scores: `${environment.BIUrl}/dashboard/copy-safety-top-drivers-by-coachable-score`,
    export_risk_top_coachable_scores: `${environment.BIUrl}/dashboard/export-safety-top-drivers-by-coachable-score`,
    share_risk_top_coachable_scores: `${environment.BIUrl}/dashboard/share-safety-top-drivers-by-coachable-score`,

    // Widget Actions - Drivers Month Over Month
    copy_risk_drivers_month_over_month: `${environment.BIUrl}/dashboard/copy-safety-risk-drivers-month-variance`,
    export_risk_drivers_month_over_month: `${environment.BIUrl}/dashboard/export-safety-risk-drivers-month-variance`,
    share_risk_drivers_month_over_month: `${environment.BIUrl}/dashboard/share-safety-risk-drivers-month-variance`,

    // Widget Actions - Safety Collision Count
    copy_safety_collision_count: `${environment.BIUrl}/dashboard/copy-safety-collision-count`,
    export_safety_collision_count: `${environment.BIUrl}/dashboard/export-safety-collision-count`,
    share_safety_collision_count: `${environment.BIUrl}/dashboard/share-safety-collision-count`,

    // Widget Actions - Safety Locations by Collisions
    copy_safety_locations_by_collisions: `${environment.BIUrl}/dashboard/copy-safety-collision-by-location`,
    export_safety_locations_by_collisions: `${environment.BIUrl}/dashboard/export-safety-collision-by-location`,
    share_safety_locations_by_collisions: `${environment.BIUrl}/dashboard/share-safety-collision-by-location`,

    // Widget Actions - Safety Collision by Drivers
    copy_collision_by_drivers: `${environment.BIUrl}/dashboard/copy-safety-collision-by-driver`,
    export_collision_by_drivers: `${environment.BIUrl}/dashboard/export-safety-collision-by-driver`,
    share_collision_by_drivers: `${environment.BIUrl}/dashboard/share-safety-collision-by-driver`,

    // Widget Actions - Top Locations by Injuries
    copy_top_locations_by_injuries: `${environment.BIUrl}/dashboard/copy-safety-injury-by-location`,
    export_top_locations_by_injuries: `${environment.BIUrl}/dashboard/export-safety-injury-by-location`,
    share_top_locations_by_injuries: `${environment.BIUrl}/dashboard/share-safety-injury-by-location`,

    // Widget Actions - Safety Injuries by Employees
    copy_safety_injuries_by_employees: `${environment.BIUrl}/dashboard/copy-safety-injury-by-employee`,
    export_safety_injuries_by_employees: `${environment.BIUrl}/dashboard/export-safety-injury-by-employee`,
    share_safety_injuries_by_employees: `${environment.BIUrl}/dashboard/share-safety-injury-by-employee`,

    // Widget Actions - Safety Injuries Lost Time
    copy_safety_injuries_lost_time: `${environment.BIUrl}/dashboard/copy-safety-injury-lost-time`,
    export_safety_injuries_lost_time: `${environment.BIUrl}/dashboard/export-safety-injury-lost-time`,
    share_safety_injuries_lost_time: `${environment.BIUrl}/dashboard/share-safety-injury-lost-time`,

    // Widget Actions - Safety Injuries Total Count
    copy_safety_injuries_total_count: `${environment.BIUrl}/dashboard/copy-safety-injury-count`,
    export_safety_injuries_total_count: `${environment.BIUrl}/dashboard/export-safety-injury-count`,
    share_safety_injuries_total_count: `${environment.BIUrl}/dashboard/share-safety-injury-count`,

    // Widget Actions - Recurring Drivers
    copy_risk_recurring_drivers: `${environment.BIUrl}/dashboard/copy-safety-risk-recurring-drivers`,
    export_risk_recurring_drivers: `${environment.BIUrl}/dashboard/export-safety-risk-recurring-drivers`,
    share_risk_recurring_drivers: `${environment.BIUrl}/dashboard/share-safety-risk-recurring-drivers`,

    // Widget Actions - Top relevant collision factors
    copy_collision_relevant_factors: `${environment.BIUrl}/dashboard/copy-safety-collision-top-relevant-factor`,
    export_collision_relevant_factors: `${environment.BIUrl}/dashboard/export-safety-collision-top-relevant-factor`,
    share_collision_relevant_factors: `${environment.BIUrl}/dashboard/share-safety-collision-top-relevant-factor`,

    // Widget Actions - Top collision counts
    copy_top_collision_counts: `${environment.BIUrl}/dashboard/copy-safety-collision-top-collision`,
    export_top_collision_counts: `${environment.BIUrl}/dashboard/export-safety-collision-top-collision`,
    share_top_collision_counts: `${environment.BIUrl}/dashboard/share-safety-collision-top-collision`,

    // Widget Actions - Top relevant injury conditions
    copy_injury_top_relevant_conditions: `${environment.BIUrl}/dashboard/copy-safety-injury-top-relevant-factor`,
    export_injury_top_relevant_conditions: `${environment.BIUrl}/dashboard/export-safety-injury-top-relevant-factor`,
    share_injury_top_relevant_conditions: `${environment.BIUrl}/dashboard/share-safety-injury-top-relevant-factor`,
  },

  SafetyIntelligence: {
    get_driver_risk_category_summary: `${environment.BIUrl}/intelligence/driver-risk-category-summary`,
    get_driver_incident_frequency_chart: `${environment.BIUrl}/intelligence/driver-incident-frequency-chart`,
    get_driver_risk_details_paginated: `${environment.BIUrl}/intelligence/driver-risk-details`,
    get_driver_segment_details_paginated: `${environment.BIUrl}/intelligence/driver-segment-details`,
    get_driver_segment_summary: `${environment.BIUrl}/intelligence/driver-segment-summary`,
    get_location_risk_level_summary: `${environment.BIUrl}/intelligence/location-risk-level-summary`,
    get_top_location_incident_predictions: `${environment.BIUrl}/intelligence/top-location-incident-predictions`,
  },
};
